import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tree } from '@myua/kit';
import * as viewModeActions from '../actions';
import { Page, routes } from '../../router/model';
import { getPage } from '../../router/selectors';
import { useHistory } from 'react-router-dom';
import { VIEW_MODES, ViewMode } from '../model';
import { getExpanded, getViewModeVisible, getViewMode } from '../selectors';
import { getCreative } from '../../viewer/selectors';
import * as viewerActions from '../../viewer/actions';
import { ArrowDown } from '@myua/icons/dist/linear14';

const GROUP_KEY = '';

const treeData = [
  {
    key: GROUP_KEY,
    title: 'View by',
    selectable: false,
    className: 'al-app-sider-tree__not-selectable',
    children: VIEW_MODES,
  },
];

export const ViewModeSelector = () => {
  const dispatch = useDispatch();
  const page = useSelector(getPage);
  const history = useHistory();
  const viewMode = useSelector(getViewMode);
  const expanded = useSelector(getExpanded);
  const creative = useSelector(getCreative);
  const isVisible = useSelector(getViewModeVisible);

  const select = (newViewMode: ViewMode) => {
    if (newViewMode !== ViewMode.assets && creative) {
      dispatch(viewerActions.creativeChanged({ creative: undefined }));
    }
    dispatch(viewModeActions.changed({ viewMode: newViewMode }));
    if (page !== Page.viewer) {
      history.push(routes.viewer);
    }
  };

  const selectedKeys = useMemo(() => [viewMode], [viewMode]);
  const expandedKeys = useMemo(() => (expanded ? [GROUP_KEY] : []), [expanded]);

  if (!isVisible) {
    return null;
  }

  return (
    <div>
      <Tree
        className="al-app-sider-tree"
        switcherIcon={<ArrowDown />}
        treeData={treeData}
        selectedKeys={selectedKeys}
        expandedKeys={expandedKeys}
        onSelect={(keys) => {
          if (keys.length !== 1) {
            return;
          }
          const key = keys[0];
          select(key as ViewMode);
        }}
        onExpand={(keys) =>
          dispatch(
            viewModeActions.expandedChanged({
              expanded: keys.length === 1 && keys[0] === GROUP_KEY,
            }),
          )
        }
      />
    </div>
  );
};
